import React from 'react';
import Icon from '../Icon/Icon';
import { Flex } from '@chakra-ui/react';
import * as styles from './ReviewIcons.module.scss';

const ReviewIcons = ({ rating, yellow = false, size = '', hideExcess = false, gap= 0 }) => {
  const roundedRating = Math.round(rating ?? 0);

  const renderIcons = () => {
    const icons = [];

    for (let i = 0; i < roundedRating; i++) {
      icons.push(
        <Icon symbol={yellow ? 'review-star' : 'star-fill'} key={i} />
      );
    }

    if (!yellow && !hideExcess)
      for (let i = roundedRating; i < 5; i++) {
        icons.push(<Icon symbol="star-outline" key={i} />);
      }

    return icons;
  };

  return (
    <Flex className={size ? styles[size] : ''} wrap={'nowrap'} gap={gap}>
      {renderIcons()}
    </Flex>
  );
};

export default ReviewIcons;
